export const iconFontAwesomeShapesShield = (
	<i className="fa-solid fa-shield"></i>
);
